export default "https://fenwan.cdn.bcebos.com/gamecenter/static/game/assets/imgs/productinfo_lowest.55c401cb.png";